import IconeAjuda from '@/global/components/IconeAjuda'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import { Link } from 'global/components/Link'
import React, { useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'

function FormularioEscala() {
    const [emHoras, setEmHoras] = useState(true)
    const { setValue } = useFormContext()

    const trabalha = useMemo(() => {
        if (emHoras) {
            return (
                <FormField
                    name="trabalha"
                    label="Trabalha (em horas)"
                    options={{
                        blocks: [2, 2],
                        delimiter: ':',
                    }}
                    onBlur={handleBlur(value => setValue('trabalha', value))}
                />
            )
        }

        return (
            <FormField
                name="trabalha"
                label="Trabalha (em dias)"
                type="number"
            />
        )
    }, [emHoras])

    const folga = useMemo(() => {
        if (emHoras) {
            return (
                <FormField
                    name="folga"
                    label="Folga (em horas)"
                    options={{
                        blocks: [2, 2],
                        delimiter: ':',
                    }}
                    onBlur={handleBlur(value => setValue('folga', value))}
                />
            )
        }

        return <FormField name="folga" label="Folga (em dias)" type="number" />
    }, [emHoras])

    return (
        <Grid container spacing={2}>
            <Grid item xs={4}>
                <FormFieldCheckbox
                    onChange={(_, check) => setEmHoras(!check)}
                    name="emHoras"
                    label="Em horas"
                />
            </Grid>
            <Grid item xs={8}>
                <Box display="flex" alignItems="center">
                    <FormFieldCheckbox
                        name="horaExtraNoFeriado"
                        label="Hora extra no feriado"
                    />
                    <IconeAjuda>
                        <li>
                            O colaborador receberá hora extra no feriado se
                            selecionado.
                        </li>
                        <br />
                        <li>
                            Por padrão, só recebe se ultrapassar a jornada de
                            trabalho.
                        </li>
                        <br />
                        <li>
                            Se não trabalhar, não há hora extra. Configure a
                            porcentagem na{' '}
                            <Link href="/cadastros/regras-calculo">
                                regra de cálculo
                            </Link>{' '}
                            na linha feriado.
                        </li>
                    </IconeAjuda>
                </Box>
            </Grid>
            <Grid item xs={6}>
                {trabalha}
            </Grid>
            <Grid item xs={6}>
                {folga}
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="descricao"
                    label="Descrição"
                    multiline
                    rows={2}
                />
            </Grid>
        </Grid>
    )
}

export default FormularioEscala

function handleBlur(fn: (value: string) => void) {
    return (
        event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        const { value } = event.target

        if (!value) return fn('')

        return fn(value.padEnd(5, '0'))
    }
}
